import _axios from '@/services/axios';
import { Component, Vue } from 'vue-property-decorator';
import WithRender from './generalsettings.html';
import config from "@/settings/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

interface SettingRow {
  key: string;
  value: string;
  isBoolean: boolean;
  boolValue: boolean;
}

@WithRender
@Component({
  components: {
    Loading,
  }
})
export default class GeneralSettings extends Vue {
  isLoading = false;
  saving = false;
  settings: SettingRow[] = [];

  mounted() {
    this.getSettings();
  }

  toRow(key: string, value: string): SettingRow {
    const normalized = (value || '').toLowerCase();
    const isBoolean = normalized === 'true' || normalized === 'false';
    return {
      key,
      value,
      isBoolean,
      boolValue: normalized === 'true'
    };
  }

  onToggle(row: SettingRow, checked: boolean): void {
    row.boolValue = checked;
    row.value = checked ? 'True' : 'False';
  }

  getSettings(): void {
    this.isLoading = true;
    _axios.get(`${config.gateway}recharge-api/GeneralSettings`)
      .then(response => {
        this.settings = Object.entries(response.data as Record<string, string>)
          .map(([key, value]) => this.toRow(key, value));
      })
      .catch(err => {
        console.error(err);
        const status = (err.response && err.response.status) || '';
        const detail = (err.response && err.response.data) || err.message || '';
        alert(`Could not load settings: ${status} ${detail}`);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  save(): void {
    this.saving = true;
    const updates: Record<string, string> = {};
    this.settings.forEach(row => updates[row.key] = row.value);

    _axios.put(`${config.gateway}recharge-api/GeneralSettings`, updates)
      .then(response => {
        this.settings = Object.entries(response.data as Record<string, string>)
          .map(([key, value]) => this.toRow(key, value));
        this.$bvToast.toast("Settings saved", {
          title: 'Notification',
          variant: 'success',
          autoHideDelay: 5000,
        });
      })
      .catch(err => {
        console.error(err);
        const status = (err.response && err.response.status) || '';
        const detail = (err.response && err.response.data) || err.message || '';
        this.$bvToast.toast(`Could not save settings: ${status} ${detail}`, {
          title: 'Notification',
          variant: 'danger',
          autoHideDelay: 5000,
        });
      })
      .finally(() => {
        this.saving = false;
      });
  }
}
